@if (loggedIn$ | async) {
  <div
    class="flex flex-col h-screen bg-background text-on-surface selection:bg-primary-container selection:text-on-primary-fixed"
    >
    <!-- TopNavBar -->
    <header
      class="w-full h-16 sticky top-0 z-50 bg-surface/80 backdrop-blur-md flex justify-between items-center px-6 border-b border-outline-variant/10"
      >
      <div class="flex items-center gap-8">
        <div class="flex items-center gap-4">
          <img src="images/PartikelART-logo.png" alt="PartikelART Logo" class="h-6 w-auto object-contain" />
          <div class="h-5 w-px bg-outline-variant/30 hidden sm:block"></div>
          <span class="text-lg font-bold text-on-surface tracking-tight">
            CASE
          </span>
        </div>
        <nav class="hidden md:flex gap-6 font-headline text-sm tracking-tight">
          <a
            class="text-primary font-bold border-b-2 border-primary"
            routerLink="/home/dashboard"
            routerLinkActive="text-primary border-primary"
            >{{ "shell.dashboard" | translate }}</a
            >
          </nav>
        </div>
        @if (userInformation$ | async; as user) {
          <div
            class="flex items-center gap-4"
            >
            <div class="relative hidden lg:block">
              <span
                class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-on-surface-variant text-sm"
                >search</span
                >
                <input
                  class="pl-10 pr-4 py-1.5 bg-surface-container-high border-none rounded-md text-sm w-64 focus:ring-1 focus:ring-primary/20"
                  placeholder="{{ 'shell.searchPlaceholder' | translate }}"
                  type="text"
                  />
              </div>
              <div class="flex gap-2">
                <!-- Notification Bell with Dropdown -->
                <div class="relative" (click)="$event.stopPropagation()">
                  <button
                    (click)="toggleNotifications($event)"
                    class="p-2 hover:bg-surface-container-high transition-colors text-on-surface rounded-full relative"
                    >
                    <span class="material-symbols-outlined">notifications</span>
                    @if (notificationBadgeCount$ | async; as count) {
                      <span
                        class="absolute -top-0.5 -right-0.5 w-4 h-4 bg-error text-on-error rounded-full text-[9px] font-black flex items-center justify-center"
                        >
                        {{ count }}
                      </span>
                    } @else {
                      @if ((recentReports$ | async)?.length) {
                        <span
                          class="absolute -top-0.5 -right-0.5 w-2 h-2 bg-primary rounded-full"
                        ></span>
                      }
                    }
                  </button>
                  <!-- Notification Dropdown Panel -->
                  @if (isNotificationsOpen) {
                    <div
                      class="absolute right-0 top-full mt-2 w-80 bg-surface-container-lowest rounded-xl shadow-xl border border-outline-variant/10 z-50 overflow-hidden"
                      >
                      <div
                        class="px-4 py-3 border-b border-outline-variant/10 flex items-center justify-between"
                        >
                        <span class="text-sm font-bold text-on-surface">{{
                          "shell.recentReports" | translate
                        }}</span>
                        <button
                          (click)="closeNotifications()"
                          class="text-on-surface-variant hover:text-on-surface"
                          >
                          <span class="material-symbols-outlined text-sm">close</span>
                        </button>
                      </div>
                      @if (recentReports$ | async; as reports) {
                        <div
                          class="max-h-80 overflow-y-auto"
                          >
                          @if (reports.length === 0) {
                            <div
                              class="px-4 py-6 text-center text-sm text-on-surface-variant"
                              >
                              {{ "shell.noReportsFound" | translate }}
                            </div>
                          }
                          @for (report of reports; track report) {
                            <button
                              (click)="navigateToReport(report)"
                              class="w-full text-left px-4 py-3 hover:bg-surface-container-high transition-colors flex items-start gap-3 border-b border-outline-variant/5 last:border-b-0"
                              >
                              <div class="flex-1 min-w-0">
                                <div class="text-sm font-semibold text-on-surface truncate">
                                  #{{ report.uuid }} —
                                  {{ report.examiner || ("shell.unknownComponent" | translate) }}
                                </div>
                                <div class="text-xs text-on-surface-variant mt-0.5">
                                  {{ report.dateOfAnalysis | date: "dd.MM.yyyy HH:mm" }}
                                </div>
                              </div>
                              @if (report.ioResult === true) {
                                <span
                                  class="shrink-0 px-1.5 py-0.5 bg-green-100 text-green-700 rounded text-[9px] font-black uppercase tracking-tighter"
                                  >{{ "shell.passed" | translate }}</span
                                  >
                                }
                                @if (report.ioResult === false) {
                                  <span
                                    class="shrink-0 px-1.5 py-0.5 bg-tertiary/10 text-tertiary rounded text-[9px] font-black uppercase tracking-tighter"
                                    >{{ "shell.failed" | translate }}</span
                                    >
                                  }
                                  @if (
                                    report.ioResult === null || report.ioResult === undefined
                                    ) {
                                    <span
                                      class="shrink-0 px-1.5 py-0.5 bg-secondary-container text-on-secondary-container rounded text-[9px] font-black uppercase tracking-tighter"
                                      >{{ "shell.pending" | translate }}</span
                                      >
                                    }
                                  </button>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <button
                        class="p-2 hover:bg-surface-container-high transition-colors text-on-surface rounded-full"
                        >
                        <span class="material-symbols-outlined">help_outline</span>
                      </button>
                    </div>
                    <!-- Language Switcher -->
                    <div class="relative">
                      <p-select
                        [options]="languages"
                        [(ngModel)]="selectedLanguage"
                        (onChange)="languageChanged($event)"
                        optionLabel="name"
                        [showClear]="false"
                        styleClass="border-none bg-surface-container-high rounded-md text-xs"
                        >
                      </p-select>
                    </div>
                    <!-- User profile stuff from original component -->
                    @if (user.siteOptions && user.siteOptions.length > 0) {
                      <div class="ml-3 relative">
                        <p-select
                          [options]="user.siteOptions"
                          [(ngModel)]="selectedSiteOption"
                          (ngModelChange)="updateSiteSelection($event)"
                          optionLabel="siteName"
                          [filter]="true"
                          filterBy="siteName"
                          [showClear]="false"
                          placeholder="{{ 'shell.selectLocation' | translate }}"
                          (onChange)="checkForOptionalNavigation()"
                          styleClass="extended-panel border-none bg-surface-container-high rounded-md text-xs"
                          >
                          <ng-template pTemplate="selectedItem">
                            @if (selectedSiteOption) {
                              <div class="flex items-center">
                                <div class="ml-2 text-xs font-medium">
                                  {{ selectedSiteOption.siteName | slice: 0 : 30
                                  }}{{
                                  selectedSiteOption.siteName.length > 30
                                  ? "..."
                                  : ""
                                  }}
                                </div>
                              </div>
                            }
                          </ng-template>
                        </p-select>
                      </div>
                    }
                    <div class="relative">
                      <button
                        (click)="isOpen = !isOpen"
                        class="w-8 h-8 rounded-full border border-outline-variant/20 overflow-hidden"
                        >
                        <img
                          class="w-full h-full object-cover"
            [src]="
              'https://avatar.oxro.io/avatar.svg?name=' +
              (user.email?.[0] ?? 'U').toUpperCase() +
              (user.email?.[1] ?? 'S').toUpperCase() +
              '&background=545e76&color=fff'
            "
                          alt="User Profile Avatar"
                          />
                      </button>
                      @if (isOpen) {
                        <div
                          class="absolute right-0 bg-surface-container-lowest rounded-xl py-2 w-56 mt-2 shadow-xl z-50 border border-outline-variant/10"
                          >
                          <div
                            class="px-4 py-2 text-xs font-bold text-on-surface-variant uppercase tracking-widest border-b border-outline-variant/10 mb-1"
                            >
                            {{ user.email }}
                          </div>
                          <button
                            (click)="editProfile()"
                            class="w-full text-left px-4 py-2 text-sm text-on-surface hover:bg-surface-container-high transition-colors flex items-center gap-2"
                            >
                            <span class="material-symbols-outlined text-sm">person</span>
                            {{ "shell.profile" | translate }}
                          </button>
                          <button
                            (click)="logout()"
                            class="w-full text-left px-4 py-2 text-sm text-error hover:bg-error-container/10 transition-colors flex items-center gap-2"
                            >
                            <span class="material-symbols-outlined text-sm">logout</span>
                            {{ "shell.logout" | translate }}
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                }
              </header>
              <div class="flex flex-1 overflow-hidden">
                <!-- SideNavBar -->
                <aside
                  class="w-64 bg-surface-container-low border-r border-outline-variant/10 flex flex-col py-6 px-4 overflow-y-auto hidden md:flex"
                  >
                  <div class="mb-8 px-2">
                    <h2 class="text-xl font-extrabold text-on-surface">
                      Options
                    </h2>
                  </div>
                  <nav class="flex-1 space-y-1 font-label text-[13px] font-medium">
                    <a
                      routerLink="/home/dashboard"
                      routerLinkActive="bg-surface-container-highest text-primary shadow-sm"
                      class="flex items-center gap-3 px-3 py-2.5 rounded-md transition-all duration-200"
                      >
                      <span class="material-symbols-outlined">dashboard</span>
                      {{ "shell.dashboard" | translate }}
                    </a>
                    <a
                      routerLink="/home/parts"
                      routerLinkActive="bg-surface-container-highest text-primary shadow-sm"
                      class="flex items-center gap-3 px-3 py-2.5 text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition-all duration-200"
                      >
                      <span class="material-symbols-outlined">precision_manufacturing</span>
                      {{ "shell.componentList" | translate }}
                    </a>
                    <a
                      routerLink="/home/specifications"
                      routerLinkActive="bg-surface-container-highest text-primary shadow-sm"
                      class="flex items-center gap-3 px-3 py-2.5 text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition-all duration-200"
                      >
                      <span class="material-symbols-outlined">tune</span>
                      {{ "shell.specifications" | translate }}
                    </a>
                    @if (trapsEnabled) {
                      <a
                        routerLink="/home/traps"
                        routerLinkActive="bg-surface-container-highest text-primary shadow-sm"
                        class="flex items-center gap-3 px-3 py-2.5 text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition-all duration-200"
                        >
                        <span class="material-symbols-outlined">biotech</span>
                        {{ "shell.particleTraps" | translate }}
                      </a>
                    }
                    <a
                      routerLink="/home/export/steps"
                      routerLinkActive="bg-surface-container-highest text-primary shadow-sm"
                      class="flex items-center gap-3 px-3 py-2.5 text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition-all duration-200"
                      >
                      <span class="material-symbols-outlined">ios_share</span>
                      {{ "shell.export" | translate }}
                    </a>
                    <a
                      routerLink="/home/vergleich"
                      routerLinkActive="bg-surface-container-highest text-primary shadow-sm"
                      class="flex items-center gap-3 px-3 py-2.5 text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition-all duration-200"
                      >
                      <span class="material-symbols-outlined">compare_arrows</span>
                      {{ "shell.comparison" | translate }}
                    </a>
                    <a
                      routerLink="/home/declining-test"
                      routerLinkActive="bg-surface-container-highest text-primary shadow-sm"
                      class="flex items-center gap-3 px-3 py-2.5 text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition-all duration-200"
                      >
                      <span class="material-symbols-outlined">trending_down</span>
                      {{ "shell.decliningTest" | translate }}
                    </a>
                    <a
                      routerLink="/home/blindwert"
                      routerLinkActive="bg-surface-container-highest text-primary shadow-sm"
                      class="flex items-center gap-3 px-3 py-2.5 text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition-all duration-200"
                      >
                      <span class="material-symbols-outlined">science</span>
                      {{ "shell.blankValueTest" | translate }}
                    </a>
                    <a
                      routerLink="/home/violet"
                      routerLinkActive="bg-surface-container-highest text-primary shadow-sm"
                      class="flex items-center gap-3 px-3 py-2.5 text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition-all duration-200"
                      >
                      <span class="material-symbols-outlined">smart_toy</span>
                      {{ "shell.violet" | translate }}
                    </a>
                    <a
                      routerLink="/home/admin/domains"
                      routerLinkActive="bg-surface-container-highest text-primary shadow-sm"
                      class="flex items-center gap-3 px-3 py-2.5 text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition-all duration-200"
                      >
                      <span class="material-symbols-outlined">admin_panel_settings</span>
                      {{ "shell.adminDomains" | translate }}
                    </a>
                  </nav>
                  <div
                    class="mt-auto pt-6 space-y-1 border-t border-outline-variant/10 font-label text-[13px] font-medium"
                    >
                    <a
                      href="mailto:support@partikel-art.de"
                      class="flex items-center gap-3 px-3 py-2.5 text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition-colors"
                      >
                      <span class="material-symbols-outlined">contact_support</span>
                      {{ "shell.support" | translate }}
                    </a>
                    <a
                      routerLink="/home/logs"
                      class="flex items-center gap-3 px-3 py-2.5 text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition-colors"
                      >
                      <span class="material-symbols-outlined">history_edu</span>
                      {{ "shell.logs" | translate }}
                    </a>
                  </div>
                </aside>
                <!-- Main Content Area -->
                <main class="flex-1 bg-surface overflow-y-auto flex flex-col">
                  <router-outlet></router-outlet>
                </main>
              </div>
            </div>
          }
